import R from 'ramda'

const SEND_FACEBOOK_DM_DISPLAY_TYPE = 'Send Facebook DM'
const SEND_FACEBOOK_DM_WIDGET_TYPE = 'SEND_FACEBOOK_MESSAGE'

const isFacebookDmWidgetAction = R.propEq('type', SEND_FACEBOOK_DM_WIDGET_TYPE)

const isPlainTextResponse = dmType => action =>
  R.pathSatisfies(R.complement(R.either(R.isNil, R.isEmpty)), [
    'message',
    dmType,
    'text'
  ])(action)

const hasFallbackMessage = R.pathSatisfies(
  R.complement(R.either(R.isNil, R.isEmpty)),
  ['message', 'fallbackMessage']
)

const hasDepletedMessage = R.pathSatisfies(
  R.complement(R.either(R.isNil, R.isEmpty)),
  ['message', 'depletedMessage']
)

const includeBackupDms = R.either(hasFallbackMessage, hasDepletedMessage)
const constructPlainTextResponse = dmType => action =>
  R.path(['message', dmType, 'text'])(action)

const constructTemplateResponse = dmType => action =>
  R.pathOr('', [
    'message',
    dmType,
    'attachment',
    'payload',
    'elements',
    0,
    'subtitle'
  ])(action)

const constructGenericTemplateAction = R.applySpec({
  type: R.always(SEND_FACEBOOK_DM_DISPLAY_TYPE),
  action: R.always('TEMPLATE_GENERIC'),
  includeBackupDms: includeBackupDms,
  fbDmText: R.cond([
    [isPlainTextResponse('message'), constructPlainTextResponse('message')],
    [R.T, constructTemplateResponse('message')]
  ]),
  fbDmFallbackText: R.cond([
    [
      isPlainTextResponse('fallbackMessage'),
      constructPlainTextResponse('fallbackMessage')
    ],
    [R.T, constructTemplateResponse('fallbackMessage')]
  ]),
  fbDmDepletedText: R.cond([
    [
      isPlainTextResponse('depletedMessage'),
      constructPlainTextResponse('depletedMessage')
    ],
    [R.T, constructTemplateResponse('depletedMessage')]
  ]),
  fbDmImageUrl: R.pathOr('', [
    'message',
    'message',
    'attachment',
    'payload',
    'elements',
    0,
    'image_url'
  ]),
  fbDmFallbackImageUrl: R.pathOr('', [
    'message',
    'fallbackMessage',
    'attachment',
    'payload',
    'elements',
    0,
    'image_url'
  ]),
  fbDmDepletedImageUrl: R.pathOr('', [
    'message',
    'depletedMessage',
    'attachment',
    'payload',
    'elements',
    0,
    'image_url'
  ]),
  fbTemplateTitle: R.pathOr('', [
    'message',
    'message',
    'attachment',
    'payload',
    'elements',
    0,
    'title'
  ]),
  fbTemplateFallbackTitle: R.pathOr('', [
    'message',
    'fallbackMessage',
    'attachment',
    'payload',
    'elements',
    0,
    'title'
  ]),
  fbTemplateDepletedTitle: R.pathOr('', [
    'message',
    'depletedMessage',
    'attachment',
    'payload',
    'elements',
    0,
    'title'
  ]),
  fbTemplateActionUrl: R.pathOr('', [
    'message',
    'message',
    'attachment',
    'payload',
    'elements',
    0,
    'default_action',
    'url'
  ]),
  fbTemplateFallbackActionUrl: R.pathOr('', [
    'message',
    'fallbackMessage',
    'attachment',
    'payload',
    'elements',
    0,
    'default_action',
    'url'
  ]),
  fbTemplateDepletedActionUrl: R.pathOr('', [
    'message',
    'depletedMessage',
    'attachment',
    'payload',
    'elements',
    0,
    'default_action',
    'url'
  ])
})

const constructCustomTemplateAction = R.applySpec({
  type: R.always(SEND_FACEBOOK_DM_DISPLAY_TYPE),
  customDmTemplate: R.pipe(
    R.prop('message'),
    R.applySpec({ message: R.prop('message') }),
    JSON.stringify
  ),
  action: R.always('TEMPLATE_CUSTOM')
})

const convertFacebookDmWidgetActionToFormAction = R.cond([
  [
    R.pathSatisfies(R.equals(true), ['isCustomTemplate']),
    constructCustomTemplateAction
  ],
  [R.T, constructGenericTemplateAction]
])

export { isFacebookDmWidgetAction, convertFacebookDmWidgetActionToFormAction }



// WEBPACK FOOTER //
// ./src/pages/widgets/mapping/actions/facebook/widget-to-form/facebook-dm.js